<template>
  <div id="dashboard-rewards">
    <v-card
      class="px-5 py-2 mt-4 mb-0 elevation-0"
      :class="{ 'sticky-filters': user.preferences.stickyFilters }"
    >
      <CommonFilters type="rewards" @filterElements="filterElements" />
    </v-card>

    <v-row>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersRewardsByMonth ref="ordersRewardsByMonth" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersRewardsByPosition ref="ordersRewardsByPosition" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommonFilters from '@/views/components/common/CommonFilters'
import OrdersRewardsByPosition from '@/views/components/dashboardDetail/orders/OrdersRewardsByPosition'
import OrdersRewardsByMonth from '@/views/components/dashboardDetail/orders/OrdersRewardsByMonth'

export default {
  components: {
    CommonFilters,
    OrdersRewardsByPosition,
    OrdersRewardsByMonth,
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    async filterElements(filters) {
      this.loading = true
      try {
        if (this.$refs.ordersRewardsByPosition)
          this.$refs.ordersRewardsByPosition.loadSummary(filters)
        if (this.$refs.ordersRewardsByMonth) this.$refs.ordersRewardsByMonth.loadSummary(filters)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
  },
}
</script>
